  export enum EnumTipoCoordenada {
    Latitud = 0,
    Longitud = 1
  }
  export enum EnumGlobals {
    EsExtranjero = 1,
    isfreereport = 1,
    AlertaOC = 19,
    LoginLenght = 30,
    LimitRequest = 4,
    MaxSizeFileInMB = 100 //En MB
  }

  export enum EnumTipoConsultaOptimizado {
    getDataGrid = 1,
    getDataCountRows = 2,
    getDataReport = 3,
  }  